export default __webpack_public_path__ + "static/media/groupIcon.c7022475.svg";